// Centralized font size tokens and resolver for exercises
export const FONT_SIZE_OPTIONS = [
  { token: 'text-xs', labelKey: 'sizeMini' },
  { token: 'text-sm', labelKey: 'sizeSmall' },
  { token: 'text-base', labelKey: 'sizeNormal' },
  { token: 'text-lg', labelKey: 'sizeMedium' },
  { token: 'text-xl', labelKey: 'sizeLarge' },
  { token: 'text-2xl', labelKey: 'sizeVeryLarge' },
  { token: 'text-3xl', labelKey: 'sizeHuge' },
  { token: 'text-4xl', labelKey: 'sizeGiant' }
];

export function resolveFontSize(token) {
  if (!token) return undefined;
  if (typeof token !== 'string') return undefined;
  const mapping = {
    'text-xs': '12px',
    'text-sm': '14px',
    'text-base': '16px',
    'text-lg': '18px',
    'text-xl': '20px',
    'text-2xl': '24px',
    'text-3xl': '30px',
    'text-4xl': '36px'
  };

  if (mapping[token]) return mapping[token];
  if (/px|rem|em|%|clamp\(/i.test(token)) return token;
  if (/^\d+$/.test(token)) return `${token}px`;
  return undefined;
}

export default {
  FONT_SIZE_OPTIONS,
  resolveFontSize
};
